import { Injectable } from '@angular/core';

export interface ToastInfo {
  title: string;
  message: string;
  option?: ToastInfoOpt;
}
export interface ToastInfoOpt {
  delay?: number;
  classNames?: string[];
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  toasts: ToastInfo[] = [];

  show(title: string, messages: any, option?: ToastInfoOpt) {
    let message: string = '';
    if(messages?.errors?.body){
      let msg = Object.values(messages.errors.body)[0]?.toString();
      if(msg){
        const transformedStr = msg.split(' ')[0].split('_').join(' ');
        message = msg.replace(/^[^\s]+/, transformedStr);
        message = message.charAt(0).toUpperCase() + message.slice(1);
      }
    }
    else if(messages?.message){
      message = messages.message;
    }
    else{
      message = messages;
    }
    this.clear();
    this.toasts.push({ title, message, option });
  }

  remove(toast: ToastInfo) {
    this.toasts = this.toasts.filter((t) => t !== toast);
  }

  clear() {
    this.toasts.splice(0, this.toasts.length);
  }
}
